import React from 'react';
import {withTranslationsAsProps} from '../../../components/translations';

import './tripboard-banner.less';

export const TripboardBanner = ({welcomeMessage, welcomeTitle}) => {
    return (
        <div className="tripboard-banner">
            <div className="tripboard-banner__text">
                <div className="tripboard-banner__title"><h2>{welcomeTitle}</h2></div>
                <div className="tripboard-banner__message text-muted">{welcomeMessage}</div>
            </div>
            <div className="tripboard-banner__image"/>
        </div>
    );
};

export default withTranslationsAsProps({
    'tripboards.main.welcome': 'welcomeMessage',
    'tripboards.main.welcome.title': 'welcomeTitle'
})(TripboardBanner);



// WEBPACK FOOTER //
// ./src/universal/tripboard/tripboard-banner/components/tripboard-banner.js